// Ответственные сделки/контакта: `assignees` — все ответственные, `assignedTo` — основной (первый).
// Старые записи могут не иметь `assignees` — тогда берём только `assignedTo`.

// Объекты пользователей (или id) -> список
export function ownersOf(doc) {
  if (!doc) return [];
  if (Array.isArray(doc.assignees) && doc.assignees.length) return doc.assignees;
  return doc.assignedTo ? [doc.assignedTo] : [];
}

// Только id
export function ownerIdsOf(doc) {
  return ownersOf(doc).map(u => String(u?._id || u)).filter(Boolean);
}

export function ownerNamesOf(doc) {
  return ownersOf(doc).map(u => u?.name).filter(Boolean);
}
